// EN
export const accomMgmt = {
  common: {
    cancel: "Abbrechen",
    save: "Speichern",
    update: "Aktualisieren",
    back: "Zurück",
    continue: "Weiter",
    optional: "(optional)",
    optionalPlaceholder: "Optional",
    processing: "Wird verarbeitet...",
    name: "Name",
    description: "Beschreibung",
    nameRequired: "Der Name ist erforderlich.",
  },

  type: {
    apartment: "Ferienwohnung",
    hotel: "Hotel",
    camping: "Campingplatz",
    villa: "Villa",
  },

  step: {
    type: "Typ",
    structure: "Struktur",
    accommodation: "Unterkunft",
  },

  step1: {
    title: "Welche Art von Unterkunft haben Sie?",
    subtitle: "Wählen Sie den Unterkunftstyp aus.",
    subtitleQuota: "Nur die Typen mit verbleibendem Kontingent in Ihrem Tarif sind aktiv.",
    subtitleFirst: "Da dies Ihre erste Unterkunft ist, können Sie jeden Typ wählen.",
    remaining: "verbleibend: {count}",
    loadingQuota: "Kontingent Ihres Tarifs wird geladen…",
  },

  step2: {
    title: "Richten Sie Ihre Unterkunft ein",
    subtitle:
      "Entscheiden Sie, ob es eine eigenständige Unterkunft sein soll oder eine mit mehreren Kalendern (mehrere Einheiten unter einer Unterkunft).",
    singleTitle: "Ein einzelner Bereich",
    singleChip: "1 Kalender",
    singleDesc: "Vermieten Sie die gesamte Wohnung über einen einzigen Kalender.",
    groupedTitle: "Mehrere Bereiche",
    groupedChip: "Mehrere Kalender",
    groupedDesc: "Sie vermieten mehrere unabhängige Bereiche innerhalb der Wohnung",
  },

  step3: {
    title: "Richten Sie die Hauptunterkunft ein",
    subtitle:
      "Dies wird der „Container“ (Inserat) sein, der mehrere Kalender zusammenfasst. Z. B. „Castle Suite“.",
    panelTitle: "Wählen Sie eine Option",
    availableCount: "Sie haben {count} gruppierte Unterkünfte verfügbar.",
    noneAvailable: "Für diesen Typ sind keine gruppierten Inserate verfügbar (legen Sie ein neues an).",
    newTitle: "Neue Hauptunterkunft anlegen",
    newDesc: "Sie legen den Namen der Hauptunterkunft fest.",
    nameLabel: "Name der Hauptunterkunft",
    namePlaceholder: "Z. B. Castle Suite",
    nameHelp: "Dieser Name wird gespeichert und Sie können mehrere Kalender gruppieren.",
    minChars: "Geben Sie mindestens 3 Zeichen ein.",
    existingTitle: "Zu einer bestehenden Unterkunft hinzufügen",
    existingDesc: "Die Einheit wird Teil einer Unterkunft, die Sie bereits angelegt haben.",
    selectLabel: "Unterkunft auswählen",
    selectPlaceholder: "Unterkunft auswählen…",
    listingOption: "{name} · {units} Einheit(en)",
    ready: "Fertig",
    noneForType: "Für diesen Typ haben Sie keine gruppierten Unterkünfte verfügbar.",
    tip: "Tipp: Diese „Hauptunterkunft“ ist der Container, dem die neue Einheit hinzugefügt wird.",
  },

  preview: {
    tab: "ihreunterkunft",
    perNight: "/Nacht",
    book: "Buchen",
    locationPlaceholder: "Land, Stadt, Straße",
    guests: "{count} Gast | {count} Gäste",
    bedrooms: "{count} Schlafzimmer | {count} Schlafzimmer",
    bathrooms: "{count} Badezimmer | {count} Badezimmer",
    amenitiesTitle: "Ausstattung",
    amenitiesEmpty: "Wählen Sie aus, um Ihrer Unterkunft Ausstattung hinzuzufügen",
    locationTitle: "Lage",
    locationEmpty: "Legen Sie die Lage fest",
    descriptionTitle: "Beschreibung",
    descriptionEmpty: "Wählen Sie aus, um Ihrer Unterkunft eine Beschreibung hinzuzufügen",
    namePlaceholder: "Name der Unterkunft",
    amenity: {
      air_conditioning: "Klimaanlage",
      heating: "Zentralheizung",
      parking: "Parkplatz",
      oven: "Backofen und Kochfeld",
      pets_allowed: "Haustiere erlaubt",
      wifi: "WLAN",
      essentials: "Grundausstattung",
      washing_machine: "Waschmaschine",
      children_allowed: "Kinder erlaubt",
      refrigerator: "Kühlschrank",
    },
  },

  amenities: {
    title: "Ausstattung und Annehmlichkeiten",
    subtitle: "Sagen Sie Ihren Gästen, was Ihre Unterkunft bietet, damit sie wissen, was sie erwartet.",
    searchPlaceholder: "Ausstattung suchen…",
    selectedCount:
      "{count} Ausstattungsmerkmal ausgewählt | {count} Ausstattungsmerkmale ausgewählt",
    noResults: 'Keine Ausstattung für „{search}“ gefunden.',
    cat: {
      all: "Alle",
      basics: "Grundausstattung",
      bathroom: "Badezimmer",
      bedroom: "Schlafzimmer und Wäsche",
      kitchen: "Küche und Essbereich",
      outdoor: "Außenbereich",
      leisure: "Freizeit und Unterhaltung",
      safety: "Sicherheit",
      family: "Familien",
      parking: "Parken",
      services: "Services",
      connectivity: "Konnektivität",
      accessibility: "Barrierefreiheit",
    },
    item: {
      wifi: "WLAN",
      essentials: "Grundausstattung",
      air_conditioning: "Klimaanlage",
      heating: "Heizung",
      indoor_fireplace: "Kamin im Innenbereich",
      hot_water: "Warmwasser",
      hangers: "Kleiderbügel",
      bed_linen: "Bettwäsche",
      towels: "Handtücher",
      shampoo: "Shampoo",
      shower_gel: "Duschgel",
      conditioner: "Spülung",
      hair_dryer: "Föhn",
      bathtub: "Badewanne",
      bidet: "Bidet",
      jacuzzi: "Whirlpool",
      outdoor_shower: "Außendusche",
      washing_machine: "Waschmaschine",
      dryer: "Trockner",
      iron: "Bügeleisen",
      clothes_drying_rack: "Wäscheständer",
      extra_pillows: "Zusätzliche Kissen und Decken",
      wardrobe: "Kleideraufbewahrung",
      blackout_curtains: "Verdunkelungsrollos oder -vorhänge",
      nearby_laundry: "Waschsalon in der Nähe",
      oven: "Backofen",
      refrigerator: "Kühlschrank",
      freezer: "Gefrierschrank",
      microwave: "Mikrowelle",
      dishwasher: "Geschirrspüler",
      cooking_basics: "Grundlegende Küchenutensilien",
      plates_cutlery: "Geschirr und Besteck",
      wine_glasses: "Weingläser",
      coffee_maker: "Kaffeemaschine",
      coffee: "Kaffee",
      kettle: "Wasserkocher",
      toaster: "Toaster",
      blender: "Mixer",
      rice_cooker: "Reiskocher",
      bread_maker: "Brotbackautomat",
      mini_fridge: "Minikühlschrank",
      stovetop: "Kochfeld",
      dining_table: "Esstisch",
      baking_sheet: "Backblech",
      bbq_grill: "Grill",
      bbq_utensils: "Grillutensilien",
      outdoor_kitchen: "Außenküche",
      outdoor_dining: "Essbereich im Freien",
      breakfast: "Frühstück",
      pool: "Pool",
      shared_pool: "Gemeinschaftspool",
      garden: "Garten",
      patio_balcony: "Terrasse oder Balkon",
      outdoor_furniture: "Gartenmöbel",
      sun_loungers: "Liegestühle",
      hammock: "Hängematte",
      fire_pit: "Feuerstelle im Freien",
      shared_fireplace: "Kamin im Gemeinschaftsbereich",
      sauna: "Sauna",
      beach_essentials: "Strandausstattung",
      beach_access: "Strandzugang",
      lake_access: "Seezugang",
      resort_access: "Zugang zur Ferienanlage",
      waterfront: "Direkt am Wasser",
      dock: "Bootssteg",
      kayak: "Kajak",
      bikes: "Fahrräder",
      ski_slope: "Skipiste",
      outdoor_playground: "Spielplatz im Freien",
      tv: "TV",
      sound_system: "Soundsystem",
      record_player: "Plattenspieler",
      piano: "Klavier",
      gym: "Fitnessraum",
      exercise_equipment: "Sportgeräte",
      games: "Brettspiele",
      giant_games: "Großspiele",
      pool_table: "Billardtisch",
      ping_pong: "Tischtennisplatte",
      bowling: "Bowlingbahn",
      arcade: "Arcade-Spiele",
      minigolf: "Minigolf",
      batting_cage: "Schlagkäfig",
      ice_rink: "Eishockeybahn",
      laser_tag: "Lasertag",
      skate_ramp: "Skate-Rampe",
      climbing_wall: "Kletterwand",
      game_console: "Spielkonsole",
      books: "Bücher und Lesestoff",
      cinema: "Kino",
      themed_room: "Themenzimmer",
      smoke_detector: "Rauchmelder",
      co_detector: "Kohlenmonoxidmelder",
      fire_extinguisher: "Feuerlöscher",
      first_aid_kit: "Erste-Hilfe-Kasten",
      fire_guard: "Kaminschutzgitter",
      safe: "Safe",
      gated_community: "Bewachte Wohnanlage",
      security_cameras: "Überwachungskameras",
      children_allowed: "Kinder erlaubt",
      crib: "Kinderbett",
      travel_cot: "Reisebett",
      baby_bath: "Babybadewanne",
      baby_safety_gates: "Treppenschutzgitter",
      changing_table: "Wickeltisch",
      high_chair: "Hochstuhl",
      children_plates: "Kindergeschirr und -besteck",
      children_books_toys: "Kinderbücher und Spielzeug",
      kids_bikes: "Kinderfahrräder",
      outlet_covers: "Steckdosensicherungen",
      table_corner_guards: "Tischkantenschutz",
      window_guards: "Fenstersicherungen",
      baby_monitor: "Babyfon",
      children_game_room: "Spielzimmer für Kinder",
      babysitter_recommendations: "Babysitter-Empfehlungen",
      parking: "Kostenloser Parkplatz auf dem Gelände",
      free_street_parking: "Kostenloses Parken auf der Straße",
      paid_parking_on_premises: "Kostenpflichtiges Parken auf dem Gelände",
      paid_parking_off_premises: "Kostenpflichtiges Parken außerhalb des Geländes",
      ev_charger: "Ladestation für Elektroautos",
      e_bike_charger: "Ladestation für E-Bikes",
      pets_allowed: "Haustiere erlaubt",
      long_term_stays: "Für Langzeitaufenthalte verfügbar",
      luggage_dropoff: "Gepäckaufbewahrung erlaubt",
      cleaning_during_stay: "Reinigung während des Aufenthalts verfügbar",
      concierge: "Concierge",
      cleaning_products: "Reinigungsmittel",
      recycling: "Recyclingbehälter",
      compactor: "Müllpresse",
      compost: "Komposteimer",
      solar_panels: "Solaranlage",
      workspace: "Arbeitsplatz",
      private_entrance: "Privater Eingang",
      private_lounge: "Privater Aufenthaltsraum",
      mosquito_net: "Moskitonetz",
      ceiling_fan: "Deckenventilator",
      portable_fans: "Mobile Ventilatoren",
      ethernet: "Ethernet-Anschluss",
      mobile_wifi: "Mobiles WLAN",
      single_floor: "Unterkunft auf einer Ebene",
      elevator: "Aufzug",
    },
  },

  room: {
    createTitle: "Zimmerkategorie anlegen",
    editTitle: "Zimmerkategorie aktualisieren",
    namePlaceholder: "Z. B. Doppelzimmer",
    countLabel: "Anzahl der Zimmer dieser Kategorie",
    countPlaceholder: "Z. B. 20",
    countHint: "Dies ist der Gesamtbestand der Kategorie. Z. B. „Doppelzimmer“ = 20 Zimmer.",
    capacityLabel: "Gesamtkapazität (max. Gäste)",
    capacityPlaceholder: "Z. B. 5",
    capacityHint:
      "Dies ist das tatsächliche Gästelimit. Auch wenn Sie Höchstwerte je Kategorie festlegen, gilt die Gesamtzahl.",
    maxAdults: "Max. Erwachsene",
    maxChildren: "Max. Kinder",
    maxInfants: "Max. Kleinkinder",
    importantLabel: "Wichtig:",
    capacityNote: "Dies sind Obergrenzen je Kategorie. Die insgesamt zulässige Zahl legt die „Gesamtkapazität“ fest.",
    physicalTitle: "Physische Zimmer (RoomInstances)",
    physicalDesc: "Aktivieren Sie dies, wenn Sie 101/102, Wartung je Zimmer und Schlösser verwalten möchten.",
    generateLabel: "Physische Zimmer automatisch erzeugen/anpassen",
    generatorTitle: "Code-Generator",
    prefixLabel: "Präfix",
    prefixPlaceholder: "Z. B. 10 oder A-",
    prefixHint: "Z. B. Präfix „10“ + Start 1 => 101, 102...",
    startLabel: "Start",
    paddingLabel: "Auffüllung",
    paddingHint: "Z. B. Auffüllung 3 => 001, 002, 003",
    nameModeType: "Nur Kategorie",
    nameModeTypeCode: "Kategorie + Code",
    defaultDescLabel: "Standardbeschreibung",
    willCreatePre: "Bis zu",
    willCreatePost: "physische Zimmer werden automatisch erstellt oder angepasst.",
    errors: {
      saveFallback: "Fehler beim Speichern der Zimmerkategorie.",
      capacityMin: "Die Gesamtkapazität muss mindestens 1 betragen.",
      adultsMin: "Es muss mindestens 1 Erwachsener zugelassen sein.",
      adultsMax: "Das Limit für Erwachsene darf die Gesamtkapazität nicht überschreiten.",
      childrenRange: "Das Limit für Kinder muss zwischen 0 und der Gesamtkapazität liegen.",
      infantsRange: "Das Limit für Kleinkinder muss zwischen 0 und der Gesamtkapazität liegen.",
      roomsMin: "Die Anzahl der Zimmer muss mindestens 1 betragen.",
      notAuth: "Benutzer nicht authentifiziert.",
    },
    toasts: {
      updated: "Kategorie aktualisiert.",
      created: "Kategorie angelegt.",
      roomsSynced: "Physische Zimmer erfolgreich erzeugt/angepasst.",
    },
  },

  rate: {
    registerHeader: "Zimmerkategorie anlegen",
    editHeader: "Tarif aktualisieren - {name}",
    createHeader: "Tarif anlegen - {name}",
    processing: "Wird verarbeitet, bitte warten.",
    general: "Allgemein",
    namePlaceholder: "Eigener Name",
    validityLabel: "Gültigkeitszeitraum",
    permanent: "Dauerhaft",
    custom: "Individuell",
    startDatePlaceholder: "Startdatum",
    endDatePlaceholder: "Enddatum",
    validityNoteCustom: "Gültigkeitszeitraum des Tarifs (optional)",
    validityNotePermanent: "Tarif dauerhaft gültig",
    pricePerNight: "Preis pro Nacht",
    taxIncluded: "Steuern inbegriffen",
    occupancy: "Belegung",
    guestsNumber: "Anzahl der Gäste",
    minStay: "Mindestaufenthalt",
    minStayNote: "Mindestanzahl der abzurechnenden Nächte",
    maxStay: "Höchstaufenthalt",
    maxStayNote: "Höchstzahl der buchbaren Nächte",
    errors: {
      rangeRequired: "Sie müssen einen gültigen Datumsbereich auswählen",
      startAfterEnd: "Das Startdatum darf nicht nach dem Enddatum liegen",
      minStay:
        "Der Mindestaufenthalt beträgt {minStay} Nächte, der gewählte Zeitraum umfasst aber {nights} Nächte",
    },
  },
};
